import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة عدد الأيام بين تاريخين - حساب الفرق بين التواريخ بدقة";
const DESCRIPTION =
  "حاسبة الأيام المجانية تساعدك على حساب عدد الأيام، الأسابيع، الأشهر، والسنوات بين تاريخين بدقة عالية. احسب الفترات الزمنية، مدة المشاريع، العمر، الإجازات، والمواعيد النهائية بسهولة.";
const KEYWORDS =
  "حاسبة الأيام, حساب الفرق بين تاريخين, عدد الأيام بين تاريخين, حاسبة التاريخ, حساب المدة الزمنية, الفرق بين التواريخ, حساب العمر, حاسبة الفترات الزمنية, حساب الأيام المتبقية";
const OG_URL = "https://do-calculate.com/calculator/ar/days-calculator/";
// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "حاسبة عدد الأيام بين تاريخين",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "الرئيسية",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "الحاسبات",
        item: "https://do-calculate.com/ar/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "حاسبة الأيام",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "كيف أحسب الفرق بين تاريخين؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "أدخل تاريخ البدء وتاريخ الانتهاء في الحقول المخصصة، ثم اضغط على زر احسب للحصول على الفرق بوحدات متعددة (أيام، أسابيع، أشهر، سنوات، ساعات).",
        },
      },
      {
        "@type": "Question",
        name: "ما هي استخدامات حاسبة الأيام؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "تُستخدم لحساب مدة المشاريع، العمر بالتفصيل، الأيام المتبقية للمناسبات، فترات الإجازات، حساب العقود، تخطيط الأحداث، وأي عمليات حسابية تتعلق بالتواريخ.",
        },
      },
    ],
  },
];

const GREGORIAN_MONTHS = [
  "يناير / كانون الثاني", "فبراير / شباط", "مارس / آذار", "أبريل / نيسان",
  "مايو / أيار", "يونيو / حزيران", "يوليو / تموز", "أغسطس / آب",
  "سبتمبر / أيلول", "أكتوبر / تشرين الأول", "نوفمبر / تشرين الثاني", "ديسمبر / كانون الأول"
];
function DaysCalculator() {
  // حالة تاريخ البدء
  const [startD, setStartD] = useState({ day: "1", month: "1", year: "2024" });
  // حالة تاريخ الانتهاء
  const [endD, setEndD] = useState({ day: "1", month: "1", year: "2025" });

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateDifference = () => {
    const start = new Date(parseInt(startD.year), parseInt(startD.month) - 1, parseInt(startD.day));
    const end = new Date(parseInt(endD.year), parseInt(endD.month) - 1, parseInt(endD.day));

    if (start > end) {
      setError("تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء");
      setResult(null);
      return;
    }

    const timeDiff = Math.abs(end - start);
    const totalDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const totalHours = Math.floor(timeDiff / (1000 * 60 * 60));

    // حسابات تقريبية للسنوات والشهور
    const years = Math.floor(totalDays / 365.25);
    const remainingDaysAfterYears = totalDays % 365.25;
    const months = Math.floor(remainingDaysAfterYears / 30.44);
    const days = Math.floor(remainingDaysAfterYears % 30.44);

    setResult({
      totalDays,
      totalHours,
      years,
      months,
      days,
      startDateFormatted: start.toLocaleDateString('ar-EG', { year: 'numeric', month: 'long', day: 'numeric' }),
      endDateFormatted: end.toLocaleDateString('ar-EG', { year: 'numeric', month: 'long', day: 'numeric' }),
    });
    setError("");
  };

  const handleClear = () => {
    setStartD({ day: "1", month: "1", year: "2024" });
    setEndD({ day: "1", month: "1", year: "2025" });
    setResult(null);
    setError("");
  };

  // مكون فرعي لاختيار التاريخ لتقليل تكرار الكود
  const DateSelector = ({ label, value, onChange }) => (
    <div className="row mb-3 align-items-center">
      <div className="col-sm-12 col-md-3">
        <label className="fw-bold">{label}</label>
      </div>
      <div className="col-sm-12 col-md-9">
        <div className="d-flex gap-2 flex-wrap">
          <select className="form-select w-auto" value={value.day} onChange={(e) => onChange({ ...value, day: e.target.value })}>
            {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
          <select className="form-select w-auto" value={value.month} onChange={(e) => onChange({ ...value, month: e.target.value })}>
            {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
          <select className="form-select w-auto" value={value.year} onChange={(e) => onChange({ ...value, year: e.target.value })}>
            {Array.from({ length: 150 }, (_, i) => new Date().getFullYear() + 20 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>حاسبة عدد الأيام بين تاريخين</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                مرحبًا بك في حاسبة الفرق بين التواريخ! تساعدك هذه الأداة المتقدمة في حساب الفارق بدقة بين تاريخين محددين باستخدام وحدات زمنية متعددة مثل الأيام، الأسابيع، الأشهر، السنوات، الساعات، الدقائق، والثواني. سواء كنت بحاجة لتخطيط المهام، إدارة المشاريع، أو ببساطة معرفة الفترات الزمنية بين تاريخين لأي غرض، فإن هذه الأداة توفر لك كل ما تحتاجه بسرعة وسهولة.
              </p>
              اتبع الخطوات التالية لاستخدام الحاسبة:
              <ul>
                <li>أدخل تاريخ البدء وتاريخ الانتهاء في الحقول المخصصة.</li>
                <li>اضغط على زر "احسب" للحصول على الفرق بين التاريخين.</li>
                <li>ستظهر النتيجة بتنسيقات متعددة لتناسب احتياجاتك.</li>
              </ul>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  احسب الفرق بين التواريخ بسهولة
                </h2>
              </div>
              {/* Date Inputs */}
              <div className="row mb-3 align-items-center">
                <DateSelector label="تاريخ البدء:" value={startD} onChange={setStartD} />
                <DateSelector label="تاريخ الانتهاء:" value={endD} onChange={setEndD} />

                <div className="text-center mt-4">
                  <button onClick={calculateDifference} className="btn btn-success btn-lg me-2 px-5">احسب</button>
                  <button onClick={handleClear} className="btn btn-secondary btn-lg px-5" style={{marginRight:'3px'}}>امسح</button>
                </div>
              </div>
              {/* Buttons */}

              {/* Error Message */}
              {error && <div className="alert alert-danger mt-3">{error}</div>}
              {/* Results */}
              {result && (
                <div className="mt-4">
                  <h3
                    style={{
                      fontSize: "18px",
                      marginBottom: "15px",
                      textAlign: "center",
                    }}
                  >
                    <strong>النتيجة:</strong>
                  </h3>

                  {/* Main Results Table */}
                  <div className="table-container">
                    <table className="table border">
                      <thead>
                        <tr style={{ backgroundColor: "#f8f9fa" }}>
                          <th style={{ padding: "12px", borderBottom: "2px solid #dee2e6" }}>الوحدة</th>
                          <th style={{ padding: "12px", borderBottom: "2px solid #dee2e6" }}>القيمة</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>الأيام</td>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.totalDays} يوم</td>
                        </tr>
                        <tr>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>الأسابيع</td>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.weeks} أسبوع و {result.remainingDaysAfterWeeks} يوم</td>
                        </tr>
                        <tr>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>الأشهر</td>
                          <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.months} شهر و {result.remainingDaysAfterMonths} يوم</td>
                        </tr>

                        {result.years > 0 && (
                          <tr>
                            <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>السنوات</td>
                            <td style={{ padding: "10px", borderBottom: "1px solid #dee2e6" }}>{result.years} سنة و {result.remainingMonthsAfterYears} شهر</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>تنسيقات إضافية للنتيجة</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                          <li>
                            ⏰ <strong>إجمالي الساعات:</strong>{" "}
                            {result.totalHours} ساعة
                          </li>
                          <li>
                            ⏰ <strong>إجمالي الدقائق:</strong>{" "}
                            {result.totalMinutes} دقيقة
                          </li>
                          <li>
                            ⏰ <strong>إجمالي الثواني:</strong>{" "}
                            {result.totalSeconds} ثانية
                          </li>
                          <li>
                            📅 <strong>إجمالي الأسابيع:</strong>{" "}
                            {result.totalWeeks} أسبوع
                          </li>
                          <li>
                            📅 <strong>إجمالي الأشهر:</strong>{" "}
                            {result.totalMonths} شهر
                          </li>
                          {parseFloat(result.totalYears) >= 1 && (
                            <li>
                              📅 <strong>إجمالي السنوات:</strong>{" "}
                              {result.totalYears} سنة
                            </li>
                          )}
                        </ul>
                        <div
                          className="alert alert-info mt-3"
                          style={{ fontSize: "14px" }}
                        >
                          <strong>💡 نصيحة:</strong> استخدم التنسيق المناسب
                          لاحتياجاتك - الأيام للفترات القصيرة، الأشهر للمشاريع
                          المتوسطة، السنوات للفترات الطويلة.
                        </div>
                      </div>
                    </div>

                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>تفاصيل التواريخ</strong>
                      </div>
                      <div className="info-section-body">
                        <div style={{ lineHeight: "1.8" }}>
                          <p>
                            <strong>📅 تاريخ البدء:</strong><br />
                            {result.startDateFormatted}
                          </p>
                          <p>
                            <strong>📅 تاريخ الانتهاء:</strong><br />
                            {result.endDateFormatted}
                          </p>
                          <hr />
                          <p>
                            <strong>⏱️ إجمالي المدة:</strong><br />
                            {result.totalDays} يوم
                          </p>
                          {result.years > 0 && (
                            <p>
                              <strong>بالتنسيق الكامل:</strong><br />
                              {result.years} سنة، {result.remainingMonthsAfterYears} شهر، {result.remainingDaysAfterMonths} يوم
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هي حاسبة الأيام بين تاريخين؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>حاسبة الأيام بين تاريخين</strong> هي أداة إلكترونية مجانية
                  تساعدك على حساب الفرق الزمني بين أي تاريخين بدقة عالية. تتيح لك
                  الحاسبة:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>حساب عدد الأيام:</strong> معرفة عدد الأيام الدقيق بين تاريخين
                  </li>
                  <li>
                    <strong>تحويل تلقائي:</strong> عرض النتيجة بوحدات مختلفة (أسابيع، أشهر، سنوات)
                  </li>
                  <li>
                    <strong>حسابات دقيقة:</strong> مراعاة السنوات الكبيسة وعدد أيام كل شهر
                  </li>
                  <li>
                    <strong>نتائج شاملة:</strong> عرض الفرق بالساعات والدقائق والثواني أيضاً
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيفية استخدام الحاسبة:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل تاريخ البدء في الحقل الأول</li>
                  <li>أدخل تاريخ الانتهاء في الحقل الثاني</li>
                  <li>اضغط على زر "احسب"</li>
                  <li>ستظهر النتيجة فوراً بتنسيقات متعددة</li>
                  <li>يمكنك توسيع الأقسام لرؤية تفاصيل إضافية</li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 ملاحظة:</strong> تاريخ البدء يجب أن يكون قبل تاريخ
                  الانتهاء. الحاسبة تأخذ في الاعتبار جميع الأيام بما في ذلك السنوات
                  الكبيسة للحصول على أدق النتائج.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>استخدامات حاسبة الأيام</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  في العمل والأعمال:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>إدارة المشاريع:</strong> حساب مدة المشاريع والمهام
                  </li>
                  <li>
                    <strong>العقود والاتفاقيات:</strong> حساب مدة العقود وتواريخ الانتهاء
                  </li>
                  <li>
                    <strong>المواعيد النهائية:</strong> معرفة الوقت المتبقي لإنجاز المهام
                  </li>
                  <li>
                    <strong>الإجازات:</strong> حساب أيام الإجازة السنوية والمرضية
                  </li>
                  <li>
                    <strong>فترات التجربة:</strong> حساب مدة فترة التجربة للموظفين
                  </li>
                  <li>
                    <strong>الضمانات:</strong> معرفة فترة الضمان المتبقية للمنتجات
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في التعليم والدراسة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>التقويم الأكاديمي:</strong> حساب عدد أيام الفصل الدراسي
                  </li>
                  <li>
                    <strong>التحضير للامتحانات:</strong> معرفة الأيام المتبقية للاستعداد
                  </li>
                  <li>
                    <strong>الإجازات الدراسية:</strong> حساب مدة العطلات
                  </li>
                  <li>
                    <strong>مدة الدورات:</strong> حساب المدة الإجمالية للدورات التدريبية
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في الحياة الشخصية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>حساب العمر:</strong> معرفة عمرك بالأيام والأشهر والسنوات
                  </li>
                  <li>
                    <strong>المناسبات الخاصة:</strong> العد التنازلي للأعياد والمناسبات
                  </li>
                  <li>
                    <strong>الذكريات:</strong> حساب عدد الأيام منذ حدث مهم
                  </li>
                  <li>
                    <strong>السفر:</strong> تخطيط الرحلات وحساب مدة الإقامة
                  </li>
                  <li>
                    <strong>الحمل:</strong> حساب أيام الحمل وموعد الولادة المتوقع
                  </li>
                  <li>
                    <strong>العلاقات:</strong> الاحتفال بذكرى الزواج أو الخطوبة
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في المجال المالي والقانوني:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>القروض:</strong> حساب مدة القرض وفترات السداد
                  </li>
                  <li>
                    <strong>الاستثمارات:</strong> حساب مدة الاستثمار والعوائد
                  </li>
                  <li>
                    <strong>المواعيد القانونية:</strong> حساب فترات التقاضي والمهل القانونية
                  </li>
                  <li>
                    <strong>الإيجارات:</strong> حساب مدة عقود الإيجار
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>فهم حساب الفرق بين التواريخ</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  حساب الفرق بين التواريخ يتطلب فهماً دقيقاً لكيفية عمل التقويم
                  وحساب الأيام:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الأساسيات:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>اليوم:</strong> الوحدة الأساسية = 24 ساعة
                  </li>
                  <li>
                    <strong>الأسبوع:</strong> 7 أيام
                  </li>
                  <li>
                    <strong>الشهر:</strong> يختلف من 28 إلى 31 يوماً
                  </li>
                  <li>
                    <strong>السنة العادية:</strong> 365 يوماً
                  </li>
                  <li>
                    <strong>السنة الكبيسة:</strong> 366 يوماً (كل 4 سنوات)
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  عدد أيام الأشهر:
                </h3>
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th>الشهر</th>
                        <th>عدد الأيام</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>يناير (كانون الثاني)</td>
                        <td>31 يوم</td>
                      </tr>
                      <tr>
                        <td>فبراير (شباط)</td>
                        <td>28 أو 29 يوم*</td>
                      </tr>
                      <tr>
                        <td>مارس (آذار)</td>
                        <td>31 يوم</td>
                      </tr>
                      <tr>
                        <td>أبريل (نيسان)</td>
                        <td>30 يوم</td>
                      </tr>
                      <tr>
                        <td>مايو (أيار)</td>
                        <td>31 يوم</td>
                      </tr>
                      <tr>
                        <td>يونيو (حزيران)</td>
                        <td>30 يوم</td>
                      </tr>
                      <tr>
                        <td>يوليو (تموز)</td>
                        <td>31 يوم</td>
                      </tr>
                      <tr>
                        <td>أغسطس (آب)</td>
                        <td>31 يوم</td>
                      </tr>
                      <tr>
                        <td>سبتمبر (أيلول)</td>
                        <td>30 يوم</td>
                      </tr>
                      <tr>
                        <td>أكتوبر (تشرين الأول)</td>
                        <td>31 يوم</td>
                      </tr>
                      <tr>
                        <td>نوفمبر (تشرين الثاني)</td>
                        <td>30 يوم</td>
                      </tr>
                      <tr>
                        <td>ديسمبر (كانون الأول)</td>
                        <td>31 يوم</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style={{ fontSize: "14px", marginTop: "10px" }}>
                  * 29 يوماً في السنة الكبيسة
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيف تعمل الحاسبة:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>تحول التاريخين إلى قيمة زمنية دقيقة</li>
                  <li>تحسب الفرق بينهما بالميلي ثانية</li>
                  <li>تحول النتيجة إلى وحدات مختلفة (أيام، أسابيع، أشهر، سنوات)</li>
                  <li>تأخذ في الاعتبار السنوات الكبيسة والأشهر المختلفة</li>
                  <li>تعرض النتيجة بطرق متعددة لسهولة الفهم</li>
                </ol>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ ميزة:</strong> الحاسبة تستخدم متوسط 30.436875 يوماً
                  للشهر و365.25 يوماً للسنة لضمان دقة النتائج على المدى الطويل.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>أمثلة عملية على استخدام حاسبة الأيام</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  مثال 1: حساب مدة مشروع
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> بدأ مشروعك في 1 يناير 2024 وانتهى في
                  31 مارس 2024. كم استغرق المشروع؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل تاريخ البدء: 2024-01-01</li>
                  <li>أدخل تاريخ الانتهاء: 2024-03-31</li>
                  <li>اضغط "احسب"</li>
                  <li>النتيجة: 90 يوماً (حوالي 3 أشهر أو 12.86 أسبوع)</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 2: حساب العمر بالتفصيل
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> ولدت في 15 يوليو 1990. كم عمرك
                  بالتفصيل؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل تاريخ الميلاد: 1990-07-15</li>
                  <li>أدخل التاريخ الحالي (أو أي تاريخ تريد حساب العمر عنده)</li>
                  <li>اضغط "احسب"</li>
                  <li>ستحصل على العمر بالسنوات والأشهر والأيام والساعات</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 3: الأيام المتبقية لحدث
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> حفل زفافك في 20 يونيو 2025. كم يوماً
                  متبقياً؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل التاريخ الحالي كتاريخ بدء</li>
                  <li>أدخل تاريخ الحدث: 2025-06-20</li>
                  <li>اضغط "احسب"</li>
                  <li>ستعرف عدد الأيام والأسابيع والأشهر المتبقية</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 4: حساب مدة عقد
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> عقد العمل يبدأ في 1 أغسطس 2024
                  وينتهي في 31 يوليو 2026. كم مدة العقد؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل تاريخ البدء: 2024-08-01</li>
                  <li>أدخل تاريخ الانتهاء: 2026-07-31</li>
                  <li>اضغط "احسب"</li>
                  <li>النتيجة: 730 يوماً (بالضبط سنتان)</li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 نصيحة:</strong> لحساب الأيام المتبقية لحدث قادم،
                  استخدم التاريخ الحالي كتاريخ بدء والتاريخ المستقبلي كتاريخ انتهاء.
                  للعد منذ حدث ماضي، اعكس الترتيب!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>نصائح لاستخدام حاسبة الأيام بفعالية</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  نصائح عامة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>تأكد من ترتيب التواريخ:</strong> تاريخ البدء يجب أن
                    يكون قبل تاريخ الانتهاء
                  </li>
                  <li>
                    <strong>استخدم التنسيق المناسب:</strong> راجع النتائج بوحدات
                    مختلفة (أيام، أسابيع، أشهر) واختر الأنسب
                  </li>
                  <li>
                    <strong>تحقق من التفاصيل:</strong> استخدم الأقسام القابلة
                    للتوسيع لرؤية معلومات إضافية
                  </li>
                  <li>
                    <strong>احفظ النتائج:</strong> التقط صورة للشاشة إذا كنت
                    بحاجة للرجوع إليها لاحقاً
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  لحسابات دقيقة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>السنوات الكبيسة:</strong> الحاسبة تأخذها في الاعتبار
                    تلقائياً
                  </li>
                  <li>
                    <strong>اختلاف الأشهر:</strong> تحسب الأيام الفعلية بغض النظر
                    عن طول الشهر
                  </li>
                  <li>
                    <strong>الساعات والدقائق:</strong> إذا كنت تحتاج دقة أكبر،
                    راجع قسم التنسيقات الإضافية
                  </li>
                  <li>
                    <strong>التقويم الميلادي:</strong> الحاسبة تستخدم التقويم
                    الميلادي (الغريغوري)
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  للاستخدام الاحترافي:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>المشاريع:</strong> استخدم النتائج بالأيام للجداول
                    الزمنية الدقيقة
                  </li>
                  <li>
                    <strong>العقود:</strong> احسب المدة الإجمالية قبل التوقيع
                  </li>
                  <li>
                    <strong>الفواتير:</strong> احسب فترات الدفع والاستحقاق بدقة
                  </li>
                  <li>
                    <strong>التخطيط:</strong> استخدم النتائج لإنشاء جداول زمنية
                    واقعية
                  </li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ ميزة:</strong> الحاسبة تعمل فوراً وبدون الحاجة
                  للإنترنت بعد تحميل الصفحة، مما يجعلها مثالية للاستخدام في أي
                  مكان وأي وقت!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>معلومات مثيرة عن التقويم والأيام</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  حقائق ممتعة عن التقويم:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>السنة الكبيسة:</strong> سميت بذلك لأن الأيام "تقفز"
                    (leap) يوماً واحداً إضافياً
                  </li>
                  <li>
                    <strong>التقويم الميلادي:</strong> سُمي نسبة إلى البابا
                    غريغوري الثالث عشر الذي أصلحه عام 1582
                  </li>
                  <li>
                    <strong>يوم مفقود:</strong> عند الانتقال من التقويم اليولياني
                    إلى الغريغوري، "فُقدت" 10 أيام!
                  </li>
                  <li>
                    <strong>أطول شهر:</strong> يوليو وأغسطس لهما 31 يوماً متتاليين
                    - وهذا نادر في التقويم
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  أرقام مثيرة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>في 100 سنة:</strong> هناك 36,524 يوماً (مع السنوات
                    الكبيسة)
                  </li>
                  <li>
                    <strong>في حياة الإنسان:</strong> متوسط 80 سنة = حوالي 29,200
                    يوم
                  </li>
                  <li>
                    <strong>الحمل:</strong> 280 يوماً تقريباً (40 أسبوعاً)
                  </li>
                  <li>
                    <strong>فترة الدراسة:</strong> 12 سنة دراسية = حوالي 2,160 يوم
                    دراسي
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في ثقافات مختلفة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>التقويم الهجري:</strong> يعتمد على دورة القمر (354
                    يوماً)
                  </li>
                  <li>
                    <strong>التقويم الصيني:</strong> يجمع بين الشمسي والقمري
                  </li>
                  <li>
                    <strong>التقويم الفرعوني:</strong> كان من أوائل التقويمات
                    الشمسية (365 يوماً)
                  </li>
                  <li>
                    <strong>التقويم المايا:</strong> كان دقيقاً جداً ومعقداً
                    ويتضمن عدة دورات
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  لماذا فبراير له 28 يوماً؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  في التقويم الروماني القديم، كان فبراير آخر شهر في السنة وكان
                  يستخدم "لتصحيح" الأيام المتبقية. عندما أُعيد ترتيب الشهور، بقي
                  فبراير بـ 28 يوماً. وفي السنوات الكبيسة، يُضاف يوم إضافي لفبراير
                  لتعويض الربع يوم الإضافي في السنة الشمسية (365.25 يوم).
                </p>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            أسئلة متكررة
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أحسب الفرق بين تاريخين؟
                </h3>
              </div>
              <div className="info-section-body">
                حساب الفرق بين تاريخين بسيط جداً:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>أدخل تاريخ البدء في الحقل الأول</li>
                  <li>أدخل تاريخ الانتهاء في الحقل الثاني</li>
                  <li>تأكد أن تاريخ البدء قبل تاريخ الانتهاء</li>
                  <li>اضغط على زر "احسب"</li>
                  <li>
                    ستظهر النتيجة فوراً بوحدات مختلفة (أيام، أسابيع، أشهر، سنوات)
                  </li>
                  <li>يمكنك توسيع الأقسام لرؤية تفاصيل إضافية</li>
                </ol>
                الحاسبة تأخذ في الاعتبار السنوات الكبيسة واختلاف عدد أيام كل شهر
                للحصول على نتائج دقيقة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل تأخذ الحاسبة السنوات الكبيسة في الاعتبار؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>نعم، بالتأكيد!</strong> حاسبة الأيام تحسب الفرق بدقة
                  تامة مع مراعاة:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>السنوات الكبيسة:</strong> التي تحتوي على 366 يوماً بدلاً من 365
                  </li>
                  <li>
                    <strong>فبراير:</strong> 29 يوماً في السنوات الكبيسة، 28 يوماً في السنوات العادية
                  </li>
                  <li>
                    <strong>اختلاف الأشهر:</strong> تحسب الأيام الفعلية لكل شهر (30 أو 31 يوماً)
                  </li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "10px" }}>
                  <strong>قاعدة السنة الكبيسة:</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>السنة تكون كبيسة إذا كانت تقبل القسمة على 4</li>
                  <li>لكن ليست كبيسة إذا كانت تقبل القسمة على 100</li>
                  <li>إلا إذا كانت تقبل القسمة على 400 (مثل 2000، 2400)</li>
                </ul>
                لذلك، يمكنك الاعتماد على الحاسبة للحصول على نتائج دقيقة حتى عند
                حساب فترات طويلة تمتد لعدة سنوات.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يمكنني حساب عمري بالتفصيل؟
                </h3>
              </div>
              <div className="info-section-body">
                لحساب عمرك بالتفصيل باستخدام حاسبة الأيام:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>أدخل تاريخ ميلادك</strong> في حقل "تاريخ البدء"
                  </li>
                  <li>
                    <strong>أدخل التاريخ الحالي</strong> (أو أي تاريخ تريد حساب
                    عمرك عنده) في حقل "تاريخ الانتهاء"
                  </li>
                  <li>اضغط "احسب"</li>
                </ol>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  ستحصل على عمرك بعدة طرق:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>عدد الأيام الإجمالي منذ ولادتك</li>
                  <li>عمرك بالسنوات والأشهر</li>
                  <li>عمرك بالأسابيع</li>
                  <li>عمرك بالساعات والدقائق (في قسم التفاصيل الإضافية)</li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>مثال:</strong> إذا ولدت في 15 يوليو 1990 وتحسب عمرك
                  في 16 يناير 2026، ستعرف أنك عشت حوالي 12,968 يوماً أو 35 سنة
                  و6 أشهر!
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أحسب الأيام المتبقية لحدث مستقبلي؟
                </h3>
              </div>
              <div className="info-section-body">
                لحساب الأيام المتبقية لحدث قادم (عيد ميلاد، زفاف، اختبار، إجازة):
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>أدخل التاريخ الحالي</strong> أو اليوم في حقل "تاريخ
                    البدء"
                  </li>
                  <li>
                    <strong>أدخل تاريخ الحدث المستقبلي</strong> في حقل "تاريخ
                    الانتهاء"
                  </li>
                  <li>اضغط "احسب"</li>
                </ol>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  ستحصل على:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>عدد الأيام المتبقية بالضبط</li>
                  <li>عدد الأسابيع والأيام المتبقية</li>
                  <li>عدد الأشهر والأيام المتبقية</li>
                  <li>وقت الانتظار بالساعات والدقائق (للمناسبات القريبة)</li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>نصيحة:</strong> يمكنك حفظ النتيجة أو التقاط صورة
                  للشاشة لتتبع العد التنازلي!
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكنني استخدام الحاسبة لتواريخ في الماضي البعيد؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  نعم! يمكنك استخدام الحاسبة لحساب الفرق بين أي تاريخين، سواء
                  كانا:
                </p>
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>في الماضي البعيد:</strong> مثل حساب عدد الأيام منذ
                    حدث تاريخي
                  </li>
                  <li>
                    <strong>في المستقبل:</strong> مثل التخطيط لأحداث قادمة
                  </li>
                  <li>
                    <strong>بين الماضي والحاضر:</strong> مثل حساب عمرك أو مدة
                    منذ حدث مهم
                  </li>
                  <li>
                    <strong>بين الحاضر والمستقبل:</strong> مثل حساب الأيام
                    المتبقية لموعد
                  </li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>ملاحظة مهمة:</strong> الحاسبة تستخدم التقويم الميلادي
                  (الغريغوري) الذي بدأ استخدامه عام 1582. للتواريخ قبل ذلك، قد
                  تكون هناك اختلافات بسيطة بسبب التقويمات المختلفة المستخدمة سابقاً.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما الفرق بين حساب الأيام بالشهور والأسابيع؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  كل طريقة لها استخدامها المناسب:
                </p>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>بالأيام:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>الأكثر دقة</li>
                  <li>مفيد للجداول الزمنية الدقيقة</li>
                  <li>مثالي للمشاريع والمواعيد النهائية</li>
                  <li>مثال: "المشروع سيستغرق 45 يوماً"</li>
                </ul>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>بالأسابيع:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>سهل الفهم للتخطيط</li>
                  <li>مفيد لجداول العمل</li>
                  <li>مثالي للحمل والمشاريع قصيرة المدى</li>
                  <li>مثال: "بقي 6 أسابيع و 3 أيام"</li>
                </ul>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>بالأشهر:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>مناسب للفترات المتوسطة والطويلة</li>
                  <li>مفيد للعقود والتخطيط المالي</li>
                  <li>يستخدم متوسط 30.44 يوماً للشهر</li>
                  <li>مثال: "العقد مدته 18 شهراً"</li>
                </ul>
                <h4 style={{ fontSize: "15px", marginTop: "10px" }}>
                  <strong>بالسنوات:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>للفترات الطويلة جداً</li>
                  <li>مفيد لحساب العمر</li>
                  <li>يستخدم 365.25 يوماً للسنة</li>
                  <li>مثال: "عمري 35 سنة و 6 أشهر"</li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 نصيحة:</strong> الحاسبة تعرض النتيجة بجميع الوحدات،
                  اختر الأنسب لاحتياجاتك!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل الحاسبة دقيقة لحساب فترات طويلة (سنوات)؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>نعم، الحاسبة دقيقة جداً</strong> حتى للفترات الطويلة
                  التي تمتد لعشرات السنين. إليك كيف تضمن الدقة:
                </p>
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>السنوات الكبيسة:</strong> تُحسب تلقائياً وبدقة تامة
                  </li>
                  <li>
                    <strong>اختلاف الأشهر:</strong> تأخذ في الاعتبار أن الأشهر
                    لها أعداد مختلفة من الأيام
                  </li>
                  <li>
                    <strong>الحسابات الدقيقة:</strong> تستخدم معادلات رياضية دقيقة
                  </li>
                  <li>
                    <strong>التقويم الغريغوري:</strong> تتبع القواعد الصحيحة
                    للتقويم الحديث
                  </li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>أمثلة على الدقة:</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>حساب العمر لشخص عمره 80 سنة - دقيق لليوم</li>
                  <li>حساب مدة عقد 10 سنوات - دقيق لليوم</li>
                  <li>حساب الفترة بين 1990 و 2026 - دقيق تماماً</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ ضمان:</strong> يمكنك الاعتماد على الحاسبة للحسابات
                  المهنية والقانونية لأنها تستخدم نفس المعادلات التي تستخدمها
                  أنظمة التواريخ الرسمية.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكنني استخدام الحاسبة على الهاتف المحمول؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>بالتأكيد!</strong> حاسبة الأيام مصممة للعمل بكفاءة على
                  جميع الأجهزة:
                </p>
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>📱 الهواتف الذكية:</strong> واجهة متجاوبة تتكيف تماماً
                    مع الشاشات الصغيرة
                  </li>
                  <li>
                    <strong>📲 الأجهزة اللوحية:</strong> تجربة مثالية على iPad
                    وأجهزة Android اللوحية
                  </li>
                  <li>
                    <strong>💻 أجهزة الكمبيوتر:</strong> واجهة كاملة مع جميع
                    المزايا
                  </li>
                  <li>
                    <strong>🌐 جميع المتصفحات:</strong> تعمل على Chrome و Safari و
                    Firefox و Edge
                  </li>
                </ul>
                <p style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <strong>مزايا إضافية للهواتف:</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>منتقي التاريخ المدمج في نظام التشغيل</li>
                  <li>سهولة التمرير والنقر</li>
                  <li>عمل فوري بدون تأخير</li>
                  <li>لا حاجة لتطبيقات إضافية</li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 نصيحة:</strong> يمكنك إضافة الحاسبة إلى الشاشة
                  الرئيسية لهاتفك للوصول السريع! فقط افتح القائمة في المتصفح
                  واختر "إضافة إلى الشاشة الرئيسية".
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DaysCalculator;